<template>
  <div class="main-container">
    <!-- breadcrumb start -->

    <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />

    <!-- breadcrumb end -->
    <tl-header type="h3" class="margintop-30">LTA Exceptions</tl-header>
    <div class="grey-rect">
      <img src="@/assets/info-2.svg" class="info-class">
      <span>Employees listed below can claim LTA 3 times in the current block 2018-2021. ( One claim in 2018 is mandatory)</span>
    </div>
    <div class="filter-class">
      <div class="selectdiv">
        <tl-select
          label="Paygroups"
          :value="paygroup"
          :options="paygroupOptions"
          @change="(val)=>changePaygroup(val)"
        />
      </div>
      <div class="selectdiv">
        <tl-select
          label="Employee Status"
          :value="empStatus"
          :options="empStatusOptions"
          @change="(val)=>changeEmpStatus(val)"
        />
      </div>
      <div class="selectdiv">
        <tl-select
          label="Criteria"
          :value="criteria"
          :options="criteriaOptions"
          @change="(val)=>changeCriteria(val)"
        />
      </div>
      <button class="filterbtn">
        <b>Apply Filters</b>
      </button>
    </div>
    <search-dropdown
      label="Search Employee Name/Code"
      :employeeData="employeeData"
      @empselected="(emp)=>selectedEmp(emp)"
    />
    <data-table
      class="margintop-30"
      :columns="tableColumns"
      :tableData="employeeData"
      :showinrow="false"
      :with-form="false"
    >
      <template v-slot:rowcontent="slotprops">
        <p v-if="slotprops.value.column.key=='documents'">
          <img src="@/assets/document.svg" alt>
          &nbsp;{{slotprops.value.record[slotprops.value.column.key]}}
        </p>
      </template>
    </data-table>
    
    <div v-show="showSuccessMsg">
      <div class="modal">
        <div class="modal-content-history">
          <div class="top-bar">
            <span class="heading_new">Add Employee</span>
          </div>
          <div class="search-cont" v-if="!showEmpCard">
            <search-dropdown
              label="Search Employee Name/Code"
              :employeeData="employeeData"
              @empselected="(emp)=>selectedEmp(emp)"
            />
            
          </div>
          <btn-grp class="btnGrp" v-if="!showEmpCard">
              <btn text="Cancel" type="secondary" @click="cancelPopup"/>
              <btn text="Save" type="primary" @click="savePopup"/>
            </btn-grp>
          <div class="selected-card" v-if="showEmpCard">
            <selected-employee-card
              @click="closeCard"
              >
              <template v-slot:empDetails>
                <span class="label"><b>{{empName}}</b></span>
                <span class="input-label">{{empId}}</span>
                <span class="input-label">{{empMail}}</span>

              <div class="claim-header">
                <span class="label"> Claim 1  </span>
                <span class="label">  Claim 2  </span>
              </div>
              <div class="claim-details">
                <span class="label"> {{claimAmt1}} ₹ 1,20,000 </span>
                <span class="label">  {{claimAmt2}} ₹ 1,20,000 </span>
              </div>
              <div class="claim-details2">
                <span class="label"> {{claimDate1}} 04 Oct 2018 </span>
                <span class="label"> {{claimDate12}}13 Dec 2019 </span>
              </div>
              </template>
            </selected-employee-card>
          </div>
          <btn-grp class="btnGrp" v-if="showEmpCard">
            <btn text="Cancel" type="secondary" @click="cancelAdd"/>
            <btn text="Add" type="primary" @click="addPopup"/>
          </btn-grp>
        </div>
      </div>
    </div>
    <bottom-action-container >
      <btn-grp slot="end">
        <btn text="Back" type="secondary" @click="cancel"/>
        <btn text="Add New" type="primary" @click="save"></btn>
      </btn-grp>
    </bottom-action-container>
  </div>
</template>
<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import selectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue"
export default {
  name: "LegacyData",
  components: {
    SearchDropdown,
    selectedEmployeeCard
  },
  data() {
    return {
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "LTA Exceptions",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/lta`
              }
        ],
      showSuccessMsg: false,
      showEmpCard: false,
      isFileReplaced: true,
      empName: '',
      empId: '',
      empMail: '',
      paygroup: "All",
      empStatus: "All",
      criteria: "All",
      paygroupOptions: [],
      empStatusOptions: ["Active", "Inactive"],
      criteriaOptions: [],
      options: [
        {
          name: "Salary Register",
          value: "salaryRegister"
        },
        {
          name: "Salary Revision",
          value: "salaryRevision"
        },
        {
          name: "LOP/RLOP",
          value: "loprlop"
        },
        {
          name: "Loan",
          value: "loan"
        },
        {
          name: "Challan Mapping",
          value: "challanMapping"
        },
        {
          name: "Quaterly Returns",
          value: "quaterlyReturns"
        }
      ],
      tableColumns: [
        {
          label: "",
          key: "image"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Department",
          key: "department"
        },
        {
          label: "Email ID",
          key: "emailId"
        },
        {
          label: "Claim 1",
          key: "claim1"
        },
        {
          label: "Claim 2",
          key: "claim2"
        },
        {
          label: "Claim 3",
          key: "claim3"
        }
      ],
      employeeData: [
        {
          image: require("@/assets/Girl.png"),
          code: "TL001",
          name: "Nelle Foster",
          department: "KJHG",
          emailId: "Roxie.Schmidt@gmail.com",
          claim1: "₹ 1,20,000    04 Oct 2018",
          claim2: "₹ 1,20,000    08 Nov 2018",
          claim3: "₹ -"
        }
      ]
    };
  },
  methods: {
    routeToMainStep() {},
    routeToSubStep() {},
    cancel() {},
    save() {
      this.showSuccessMsg = true;
      this.isFileReplaced = false;
      this.popupType = "Success";
      this.popupMessage = "Salary Register file submitted.";
    },
    onSelect(event) {
      //console.log(event);
    },
    addFile() {
      this.showSuccessMsg = true;
      this.isFileReplaced = true;
      this.popupType = "Warning";
      this.popupMessage =
        "A file named 'EmpCode_5468' under Salary Revision already exists.";
    },
    backfrompopup() {
      this.showSuccessMsg = false;
    },
    changePaygroup(val) {
      //console.log("paygroup", val);
      this.paygroup = val;
      this.filterDropdownData(this.paygroup);
    },
    changeMonth(val) {
      //console.log("month", val);
      this.month = val;
      this.filterDropdownData(this.month);
    },
    changeEmpStatus(val) {
      //console.log("emp status", val);
      this.empStatus = val;
      this.filterDropdownData(this.empStatus);
    },
    changeCriteria(val) {
      //console.log("criteria", val);
      this.criteria = val;
      this.filterDropdownData(this.criteria);
    },
    searchDropdownData(selectedData) {
      let searchObj = selectedData;
      //console.log("search dropdown data selected", searchObj);
      if (searchObj != null && searchObj.toLowerCase() !== -1) {
        this.fetchReport(searchObj);
        //console.log("fetched", searchObj);
      }
    },

    filterDropdownData(searchSelect) {
      if (searchSelect.length) {
        this.filterDrpData = this.searchDropdownData(searchSelect);
      }
    },
    selectedEmp(emp) {
      //console.log("emp sleected data", emp);
      this.showSelectedEmployee = true
      this.empName = emp.name;
      this.empId = emp.code;
      this.empMail = emp.emailId
    },
    cancelPopup() {
      this.showSuccessMsg = false
    },
    savePopup() {
      this.showEmpCard = true
    },
    cancelAdd() {
      this.showEmpCard = false
    },
    addPopup() {
      this.showEmpCard = false
      this.showSuccessMsg = false
    },
    closeCard() {
      this.showEmpCard = false
    }
    
  }
};
</script>
<style lang="scss" scoped>
.grey-rect {
  width: 1130px;
  height: 50px;
  border-radius: 4px;
  padding: 15px;
  background-color: #f9f9f9;
  display: flex;
  justify-content: flex-start;
  span {
    font-size: 12px;
    font-style: Montserrat;
    color: #646464;
    margin: 2px;
  }
}
.info-class {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.filter-class {
  display: flex;
  margin-top: 25px;
  margin-bottom: 45px;
}
.selectdiv {
  width: 206px;
  margin-right: 15px;
}
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
}

.modal-content-history {
  background-color: white;
  margin: 60px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 375px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  position: relative;

  .datatableClass {
    margin-left: 10%;
    margin-top: 5%;
    overflow-y: scroll;
  }
}
.top-bar {
  background-color: #34c0be;
  display: flex;
  position: absolute;
  width: 100%;
  height: 50px;
}
.search-cont {
  padding: 80px;
  position: relative;
  display: flex;
  flex-direction: column;

}
.heading_new {
  font-family: Montserrat;
  font-size: 22px;
  font-weight: bold;
  padding: 10px;
  color: #ffffff;
}
.btnGrp {
  margin-top: 90px;
  margin-left: 35px;

}
.selected-card {
  margin-top: 80px;
  margin-left: 65px;
}
.claim-header {
  display: flex;
  margin-top: 15px;
  span {
    margin-right: 54px;
    font-size: 14px;
    color: #646464;
    font-weight: 600;
  }
}
.claim-details {
  display: flex;
  span {
    margin-right: 38px;
    font-size: 14px;
    color: #646464;
  }
}
.claim-details2 {
  display: flex;
  span {
    margin-right: 26px;
    font-size: 14px;
    color: #646464;
  }
}
.filterbtn {
  width: 95px;
  height: 35px;
  border-radius: 4px;
  border: solid 1px #34c0be;
  color: #34c0be;
  margin-top: 20px;

  b {
    font-size: 12px;
  }
}
</style>
